// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","breadcrumbs":"Breadcrumbs__breadcrumbs--IG","separator":"Breadcrumbs__separator--gb","highlight":"Breadcrumbs__highlight--Cm"};